import { Theme } from '@mui/material';

export const loadingSx = (theme: Theme) => ({
  color: theme.colors.white,
});
